import { PropsWithChildren } from "react";

import ShowSidebarButton from "@apps/main/components/show-sidebar-button";
import useUiPreferenceCache from "@apps/use-ui-preference-cache/use-ui-preference-cache";
import { classNames } from "@helpers/css";

type Props = {
  ariaLabel?: string;
  maxWidth?: "lg" | "7xl" | "full";
  padding?: "default" | "settings";
};

const SettingsFloatingHeader = () => {
  const { uiPreferenceCache } = useUiPreferenceCache();
  const sidebarIsExpanded = uiPreferenceCache.leftNavigationSidebarExpanded;
  return (
    <div
      className={classNames(
        "fixed z-sticky top-0 left-0 right-0 flex items-center gap-4 bg-white py-2 px-4 tf-print-display-none",
        // On desktop, hide this header when the sidebar is visible (expanded).
        // On mobile, always render it — the sidebar is never rendered on the
        // page itself, only as an overlay, so the user still needs the button.
        sidebarIsExpanded && "md:hidden",
      )}
    >
      <ShowSidebarButton />
    </div>
  );
};

const MainContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  ariaLabel,
  maxWidth = "7xl",
  padding = "default",
}) => (
  <main
    className={classNames(
      "flex-1 relative z-0 focus:outline-none",
      padding === "settings" && "bg-white",
    )}
    aria-label={ariaLabel}
  >
    {padding === "settings" && <SettingsFloatingHeader />}
    <div
      className={classNames(
        "mx-auto",
        padding === "default" && "py-6 sm:px-6 lg:px-8",
        padding === "settings" && "px-6 md:px-16 py-12",
        maxWidth === "lg" && "max-w-screen-lg",
        maxWidth === "7xl" && "max-w-7xl",
        maxWidth === "full" && "",
      )}
    >
      {children}
    </div>
  </main>
);

export default MainContainer;
